<template>
  <div>
    <section class="project-detail">
      <div class="project-detail__image">
        <img :src="require(`@/assets/${image}`)" :alt="name" />
      </div>
      <div class="project-detail__text">
        <h2 class="project-detail__title">
          {{ name }}
        </h2>
        <p class="project-detail__description">{{ description }}</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    name: String,
    description: String,
    image: String,
  },
  computed: {},
};
</script>

<style scoped>
.project-detail {
  margin-top: 64px;
  margin-bottom: 64px;
}

.project-detail__text {
  margin: 32px 24px;
  position: relative;
}

.project-detail__title {
  font-family: "Titillium Regular", sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  background-color: var(--color-black);
  padding: 0 16px;
  border-radius: 50px;
  display: inline-block;
  transform: translate(-8px, 50%);
}

.project-detail__description {
  font-family: "Titillium Regular", sans-serif;
  font-weight: 400;
  font-size: 18px;
  background-color: var(--color-yellow);
  color: var(--color-black);
  padding: 24px 16px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.project-detail__image {
  height: auto;
  width: 100%;
}

.project-detail__image img {
  width: 100%;
}
</style>
